import React,{useState,useEffect} from 'react';
import { NavLink } from "react-router-dom";
import Table from "../../components/Table"
import Selector from "../../components/Selector"
import StateContext from '../../helpers/ContextState';
import Config from '../../helpers/Config';

const App=(props)=>{
  const context = React.useContext(StateContext);
  const [param, setParam] = useState({tipo_usuario_id:2});

  let tds = [
    { 
      label:"N. Comprobante", 
      value:"nComprobante", 
      className:"col-sm-1 text-center", 
      classNameHeader:"text-center" 
    },
    { 
      label:"Proveedor", 
      value:"proveedor", 
      className:"text-left", 
      classNameHeader:"col text-center" 
    },
    { 
      label:"NIT", 
      value:"nro_documento_proveedor", 
      className:"text-center", 
      classNameHeader:"col text-center" 
    },
    { 
      label:"Producto", 
      value:"producto", 
      className:"text-left", 
      classNameHeader:"col text-center" 
    },
    { 
      label:"Marca", 
      value:"marca", 
      className:"text-left", 
      classNameHeader:"col text-center" 
    },
    { 
      label:"Planta", 
      value:"planta", 
      className:"text-center", 
      classNameHeader:"col text-center" 
    },
    { 
      label:"Semestre", 
      value:"semestre", 
      className:"text-center", 
      classNameHeader:"col text-center" 
    },
    { 
      label:"Semana", 
      value:"semana_recibido", 
      className:"text-center", 
      classNameHeader:"col text-center" 
    },
    { 
      label:"Fecha_Compra", 
      value:"fecha_recibido_string", 
      className:"col-sm-1 text-center", 
      classNameHeader:"text-center" 
    },
    { 
      label:"Fecha_Contabilizacion", 
      value:"fecha_sistema_string", 
      className:"col-sm-1 text-center", 
      classNameHeader:"text-center" 
    },
    { 
      total:true, 
      label:"Cantidad", 
      value:"cantidad_format", 
      className:"text-center", 
      classNameHeader:"col text-center" 
    },
    { 
      total:true, 
      label:"Peso", 
      value:"peso_format", 
      className:"text-center", 
      classNameHeader:"col text-center" 
    },
    { 
      label:"P_Unitario", 
      value:"precio_unit_string", 
      className:"text-center", 
      classNameHeader:"col text-center" 
    },
    { 
      total:true, 
      label:"Subtotal", 
      value:"subtotal_string", 
      className:"text-center", 
      classNameHeader:"col text-center" 
    },
    { 
      total:true, 
      label:"IVA", 
      value:"iva_string_calc", 
      className:"text-center", 
      classNameHeader:"col text-center" 
    },
    { 
      total:true, 
      label:"Total", 
      value:"total_string", 
      className:"text-center", 
      classNameHeader:"col text-center" 
    },
  ]

  return <div className="container-fluid">
    <div className="row">
      <div className="col">
        <Table
          customFiltersI={true}
          total={true}
          toExport={Config.ConfigApirest+'Excel/Informes/ListadoPagosPeriodosAnterioresExcel/token:'+context.user.token}
          toPDF={Config.ConfigApirest+'PDF/Informes/ListadoPagosPeriodosAnterioresFiltro/'+context.user.token}
          td={tds}
          modelo="Informes"
          metodo="ListadoPagosPeriodosAnterioresFiltro"
          limit="10"
          params={param}
          totalizacion={true}
        />
      </div>
    </div>
  </div>
}
export default App
